__turbopack_context__.v({
  "icon": "b9lI-G_icon",
  "root": "b9lI-G_root",
});
